import Vue from "vue";

const ApiService = require("ceres/app/services/ApiService");
import TranslationService from "ceres/app/services/TranslationService";
import NotificationService from "ceres/app/services/NotificationService";
import ExceptionMap from "ceres/app/exceptions/ExceptionMap";

export default  Vue.component("order-history", {

    delimiters: ["${", "}"],

    props: {
        template:
        {
            type: String,
            default: "#vue-order-history"
        },
        orderDetailsTemplate:
        {
            type: String,
            default: "Ceres::Checkout.OrderDetails"
        }
    },

    data()
    {
        return {
            currentOrder: null,
            isLoading: false
        };
    },

    methods:
    {
        setCurrentOrder(order)
        {
            $("#dynamic-twig-content").html("");
            this.isLoading = true;
            this.currentOrder = order;

            Vue.nextTick(() =>
            {
                $(this.$refs.orderDetails).modal("show");
            });

            ApiService
                .get("/rest/io/order/template?template=" + this.orderDetailsTemplate + "&orderId=" + order.order.id)
                .done(response =>
                {
                    this.isLoading = false;
                    $('#dynamic-twig-content').html(response);

                    $('#dynamic-twig-content').
                    append(
                        '<div class="row">' +
                        '<div class="col">' +
                        '<button class="js--buy-again btn btn-primary btn-primary--buy-again mt-5 float-right">' +
                        TranslationService.translate(
                            'Gejo::Template.buyAgainButton') +
                        '</button>' +
                        '</div>' +
                        '</div>',
                    );
                    let that = this;
                    $('#dynamic-twig-content').
                    find('.js--buy-again').
                    off('click').
                    on('click', function() {
                        that.addToBasket();
                        Vue.nextTick(() => {
                            $(that.$refs.orderDetails).modal('hide');
                        });
                    });
                });
        },
        addToBasket() {
            let that = this;
            let showSuccess = true;
            let itemCount = this.currentOrder.order.orderItems.length;
            let indexCount = 0;
            this.currentOrder.order.orderItems.forEach(
                function(item) {
                    //item.bundleType !== 'bundle_item' &&
                    if (item.itemVariationId !== 0 &&
                        item.amounts[0].priceNet > 0) {
                        const basketObject =
                            {
                                variationId: item.itemVariationId,
                                quantity: item.quantity,
                                basketItemOrderParams: item.orderProperties,
                            };

                        that.$store.dispatch('addBasketItem', basketObject).
                        then(
                            response => {
                                indexCount++;
                                document.dispatchEvent(
                                    new CustomEvent(
                                        'afterBasketItemAdded',
                                        {detail: basketObject}));

                                if (indexCount === itemCount &&
                                    showSuccess) {
                                    //show Success Notification
                                    NotificationService.success(
                                        TranslationService.translate(
                                            'Gejo::Template.buyAgainSuccess')).
                                    closeAfter(5000);

                                    //show basket Preview
                                    const vueApp = document.querySelector(
                                        '#vue-app');

                                    if (vueApp) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                    }
                                }
                            },
                            error => {
                                indexCount++;
                                console.log(error);
                                showSuccess = false;
                                if (error.data) {
                                    //show error Notification forEach
                                    // variation
                                    NotificationService.error(
                                        'Variation-Id: ' +
                                        item.itemVariationId + '<br>' +
                                        item.orderItemName + '<br>' +
                                        TranslationService.translate(
                                            'Ceres::Template.' +
                                            ExceptionMap.get(
                                                error.data.exceptionCode.toString()),
                                        ),
                                    );
                                }
                            },
                        );
                    }
                    else {
                        indexCount++;
                    }
                },
            );
        },
    }
});
